import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const SlotsDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Shift Details</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default SlotsDetailHeader;
